import type { ReactNode } from 'react';
import styles from './Skeleton.module.css';

export function Skeleton({ className = '' }: { className?: string }) {
  return <span className={`${styles.shape} ${className}`} />;
}

/** One CSS opacity animation per region, with no timers or per-block layers. */
export function SkeletonRegion({ label, children, className = '' }: {
  label: string; children: ReactNode; className?: string;
}) {
  return <div className={className} role="status" aria-live="polite" aria-busy="true">
    <span className={styles.srOnly}>{label}</span>
    <div className={styles.content} aria-hidden="true">{children}</div>
  </div>;
}
